import { useEffect } from 'react';

const DEFAULT_TITLE = 'ResiAX — The tenant support app for repairs, evidence and rights';
const DEFAULT_DESCRIPTION = 'ResiAX helps residents organise repairs and housing concerns, keep photos, messages and documents together, and share selected information on their terms. Join the supported eight-week pilot.';

export const usePageMeta = (title, description) => {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', description);
    return () => {
      document.title = DEFAULT_TITLE;
      if (meta) meta.setAttribute('content', DEFAULT_DESCRIPTION);
    };
  }, [title, description]);
};
